import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import AlertError from "./AlertError";

const DialogLayout = ({
    dialogTitle = "",
    dialogLabelledBy = "",
    dialogId = "",
    dialogContentText = "",
    mainActionClick = null,
    mainActionColor = "info",
    mainActionText = "",
    handleDialog = null,
    isDialogOpen = null,
    error = null,
}) => {
    const handleCloseDialog = () => {
        handleDialog(false);
    };

    return (
        <Dialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            aria-labelledby={dialogLabelledBy}
            aria-describedby={dialogContentText}
        >
            <DialogTitle id={dialogId}>{dialogTitle}</DialogTitle>
            <AlertError error={error} />
            <DialogContent>
                <DialogContentText id={`${dialogId}-dialog`}>
                    {dialogContentText}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog} autoFocus>
                    Cancelar
                </Button>
                <Button
                    onClick={mainActionClick}
                    color={mainActionColor}
                    variant="contained"
                >
                    {mainActionText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogLayout;
